import * as Request from '../../request'
import * as Constants from './constants'

export type FetchReference = Request.Request
export const fetchReferenceData: FetchReference = (selectedCommunity) =>
  Request.requestActionCreator(Constants.FETCH_REFERENCE_DATA)({
    method: 'GET',
    url: `${Constants.SERVER_RESOURCE}/${selectedCommunity}`,
  })



// WEBPACK FOOTER //
// ./src/pages/reference/actions.ts